<template lang="pug">
  ul
    li(v-for="item in getUrls", :key="item.url")
      a(:href="item.url" target="_blank") {{ item[currentLang] }}
</template>

<script>
import TermsLinksMixin from "../../mixins/terms/TermsLinksMixin";

export default {
  name: "TermsList",
  mixins: [TermsLinksMixin],
};
</script>
